import { NotificationService } from './../../../../services/notification.service';
import { Component, EventEmitter, Input, OnInit, Output, output, } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';
import { ButtonModule } from 'primeng/button';
import { ProjectService } from '../../../../services/project.service';
import { ToastrService } from 'ngx-toastr';
import { SuccessModalComponent } from '../../../../shared/components/success-modal/success-modal.component';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
interface EventItem {
  status?: string;
  subStatus?: string[];
  date?: string;
  icon?: string;
  color?: string;
  image?: string;
}
@Component({
  selector: 'app-project-submission',
  standalone: true,
  imports: [
    TimelineModule,
    ButtonModule,
    SuccessModalComponent,
    TranslateModule
  ],
  templateUrl: './project-submission.component.html',
  styleUrl: './project-submission.component.scss'
})

export class ProjectSubmissionComponent implements OnInit {
  completionStatus!: any
  is_complete_status!: boolean
  @Input() is_submitted!: boolean;
  is_allowed_to_submit!: boolean;
  is_already_approved!: boolean;
  @Input() strategyId = 0;
  @Input() projectId = 0;
  @Input() projectName!: string;
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";

  @Output() isSubmissionCreated = new EventEmitter<{created: boolean, submissionId: number}>();
  isSuccessModalVisible = false;
  
  // Expose state for parent component
  get canSubmit(): boolean {
    return this.is_complete_status && this.is_allowed_to_submit;
  }
  
  constructor(
    private projectService: ProjectService,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private directionService: DirectionService
  ) {
  }



  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.locale = dir == "rtl" ? "ar" : "en";
    })
    this.projectService.GetCompletionStatus(this.strategyId, this.projectId).subscribe((response: any) => {
      const { completionStatus, is_complete_status, is_allowed_to_submit, is_already_approved } = response['data']
      this.completionStatus = completionStatus;
      this.is_complete_status = is_complete_status;
      this.is_allowed_to_submit = is_allowed_to_submit;
      this.is_already_approved = is_already_approved;
    })
  }

  submit() {
    // Check if data is complete before submitting
    if (!this.is_complete_status) {
      const missingItems = this.completionStatus
        .filter((item: any) => !item.isComplete)
        .map((item: any) => this.dir === 'rtl' ? item.name_ar : item.name_en)
        .join('، ');
      
      const message = this.dir === 'rtl' 
        ? `يرجى إكمال البيانات التالية: ${missingItems}`
        : `Please complete the following data: ${missingItems}`;
      
      this.toastr.error(message, this.dir === 'rtl' ? 'بيانات ناقصة' : 'Incomplete Data');
      return;
    }
    
    if (!this.is_allowed_to_submit) {
      const message = this.dir === 'rtl' 
        ? 'لا يمكن تقديم الطلب في الوقت الحالي'
        : 'Cannot submit request at this time';
      this.toastr.error(message);
      return;
    }
    
    this.projectService.CreateSubmission(this.strategyId, this.projectId).subscribe({
      next: (response: any) => {
      this.is_allowed_to_submit = false;
      this.isSuccessModalVisible = true;
      const submissionId = response?.data?.projectAssessment?.id || 0;
      this.isSubmissionCreated.emit({created: true, submissionId: submissionId});
      this.notificationService.pushProjectSubmissionRequest(
        +this.strategyId,
        +this.projectId,
        this.locale
      );
      setTimeout(() => {
        this.isSuccessModalVisible = false;
      }, 3000)
      },
      error: (err) => {
        const apiMessage = err?.error?.error?.message || err?.error?.message;
        const message = apiMessage
          || (this.dir === 'rtl'
            ? 'تعذر تقديم المبادرة. تأكد أن لديك صلاحية الإرسال للمدير الأعلى.'
            : 'Could not submit the initiative. Make sure you can send it to your manager.');
        this.toastr.error(message);
      }
    })
  };
}
